import React,{useEffect,useState} from "react";

import API from "../../../services/api";

import {

    Landmark,

    CalendarDays,

    CheckCircle2,

    Clock3

} from "lucide-react";

import "./WithdrawalCard.css";

function WithdrawalCard(){

    const [withdrawals,setWithdrawals]=useState([]);

    const [balance,setBalance]=useState(0);

    const [loading,setLoading]=useState(true);

    useEffect(()=>{

        fetchWithdrawals();

    },[]);

    const fetchWithdrawals=async()=>{

        try{

            const response=await API.get(

                "/delivery/earnings/withdrawals"

            );

            if(response.data.success){

                setWithdrawals(response.data.withdrawals);

                setBalance(response.data.withdrawableBalance);

            }

        }

        catch(error){

            console.log(error);

        }

        finally{

            setLoading(false);

        }

    };

    if(loading){

        return <p>Loading Withdrawals...</p>;

    }

    return(

        <div className="withdraw-section">

            <div className="section-title">

                <h2>

                    Withdrawal History

                </h2>

                <h3>

                    Balance ₹{balance}

                </h3>

            </div>

            {

                withdrawals.map(item=>(

                    <div

                        key={item.id}

                        className="withdraw-card"

                    >

                        <div className="withdraw-left">

                            <div className="withdraw-icon">

                                <Landmark size={22}/>

                            </div>

                            <div>

                                <h3>

                                    {item.bank}

                                </h3>

                                <p>

                                    ₹{item.amount}

                                </p>

                            </div>

                        </div>

                        <div className="withdraw-right">

                            <div

                                className={

                                    item.status==="Available"

                                    ?

                                    "withdraw-status completed"

                                    :

                                    "withdraw-status pending"

                                }

                            >

                                {

                                    item.status==="Available"

                                    ?

                                    <CheckCircle2 size={15}/>

                                    :

                                    <Clock3 size={15}/>

                                }

                                {item.status}

                            </div>

                            <div className="withdraw-date">

                                <CalendarDays size={14}/>

                                {

                                    new Date(item.date)

                                    .toLocaleDateString()

                                }

                            </div>

                        </div>

                    </div>

                ))

            }

        </div>

    );

}

export default WithdrawalCard;